// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"0e90205c","239":"ad40150f","455":"fcb49868","977":"65f29046"}[chunkId] + ".chunk.js";
};